<template>
  <v-container>
    <v-row align="center">
      <v-col cols="12" md="auto">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 pt-0"/> 
      </v-col>
    </v-row>
    <v-tabs 
      v-model="activeTab"
      show-arrows
      right
    >
      <v-tab 
        v-for="tab in tabs" 
        :key="tab.id" 
        :to="tab.route"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-divider/>
    <v-tabs-items>
      <router-view/>
    </v-tabs-items>
  </v-container>
</template>
<script>
  import { mapState } from 'vuex';
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  export default {
    components: { 
      BaseBreadcrumbs
    },
    data () {
      return {
        activeTab: null,
        crumbs: [],
        tabs: [{ 
          id: 1, 
          name: "Thông tin cá nhân", 
          route: `/user/profile` 
        },
        { 
          id: 8, 
          name: "Hỏi đáp kỹ thuật", 
          route: `/user/supports` 
        }],
        user: null
      }
    },
    computed: {
      ...mapState([
        'authMod'
      ])
    },
    mounted () {
      this.crumbs = [
        {
          text: 'Trang chủ',
          disabled: false,
          href: '/',
        },
        {
          text: 'Người dùng',
          disabled: true
        }
      ]
      axios.get(`api/v1/users/${this.authMod.user.user.id}`)
        .then(response => {
          this.user = response.data;
          if(this.user.info && this.user.info.business){
            this.tabs.push(
            // { 
            //   id: 2, 
            //   name: "Doanh nghiệp", 
            //   route: `/user/business/info` 
            // },
            // { 
            //   id: 6, 
            //   name: "Đối tác", 
            //   route: `/user/business/coops` 
            // },
            // { 
            //   id: 3, 
            //   name: "Sản phẩm", 
            //   route: `/user/business/products` 
            // },
            // { 
            //   id: 5, 
            //   name: "Phản hồi", 
            //   route: `/user/business/feedbacks` 
            // }
            );
            this.tabs.sort(
              (a,b) => a.id - b.id
            );
          }
        })
        .catch(function (error) {
          console.log(error);
        });  
    }
  }
</script>